import React from "react";
import "./styles/FeaturedItems.css";

const FeaturedItems = ({ featuredItems }) => {
  return (
    <section className="featured-section-container">
      <h2 className="featured-title">Featured Items</h2>
      <div className="featured-grid">
        {featuredItems.length > 0 ? (
          featuredItems.map((item, index) => (
            <div className="featured-card" key={item._id || index}>
              <img src={item.imageUrl} alt={item.name} className="featured-img" />
              <h3 className="item-name">{item.name}</h3>
              <p className="item-deal">{item.description}</p>
            </div>
          ))
        ) : (
          <p className="no-featured">No featured items available.</p>
        )}
      </div>
    </section>
  );
};

export default FeaturedItems;
